import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://team.thebestdeals.app/api",
  timeout: 10000,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    withCredentials: true,
  },
});

export default axiosInstance;
